import RootStore from './RootStore'

const baseUrl = process.env.REACT_APP_BACKEND_HOST || ''
const storeIns = new RootStore({
  baseUrl,
})
storeIns.start()

export default storeIns
